import {
  call,
  put,
  takeLatest,
  select,
  actionChannel,
  take,
} from "redux-saga/effects";
import {
  addInvoiceToGroupedBookingAction,
  affiliatePaymentStatusAction,
  ammendmentCheckedAction,
  bookingHistoryCreateAction,
  bookingInitiateWithVehicleAction,
  bookinginProgressForPOBAction,
  boookingPaymentAction,
  changeBookingStatusToPobAction,
  checkDestinationIsInRegionAction,
  checkSourceIsInRegionAction,
  confirmBookingWithPassengerDetailAction,
  createDuplicateBookingAction,
  createGroupBookingAction,
  createMultipleDuplicateBookingAction,
  deleteCreditCardsFromBookingAction,
  driverDetailMailAction,
  flightApiAction,
  flightArrivalDateApiAction,
  flightDepartureDateApiAction,
  generatedBookingIdAction,
  getAirPortDbAction,
  getAllAmmendmentAction,
  getAllBookingWithSearchAction,
  getAllBookingWithoutSearchAction,
  getAllFinAmmendmentAction,
  getAllFinUncheckedAmmendmentCountAction,
  getAllOpsAmmendmentAction,
  getAllOpsUncheckedAmmendmentCountAction,
  getAllUncheckedAmmendmentCountAction,
  getBookingDetailsAction,
  getBookingDetailsByIdAction,
  getCurrencyLayerApiAction,
  getDistanceBetweenSourceAndDestinationAction,
  getDistanceBetweenSourceAndDestinationMapboxAction,
  getGroupIdsAction,
  getISTConvertedTimeAction,
  getLatLongDestinationAction,
  getLatLongSourceAction,
  getMatchingRegionsAction,
  getTimeDetailsAction,
  getTrackingDetailAction,
  getVehicleUnitPriceAction,
  groupInBookingsAction,
  groupOutBookingsAction,
  jobsForTodayAction,
  jobsForTomorrowAction,
  passengerDetailsUpdateAction,
  searchVehicleWithPriceFlateRateAction,
  searchVehiclesAction,
  searchVehiclesHourlyPriceAction,
  sendAffiliateVoucherAction,
  sendCancelBookingVoucherAction,
  sendInvoiceAction,
  sendVoucherAction,
  sendVoucherb2cAction,
  sendWatiMsgAction,
  totalBokingAction,
  unassignedJobsAction,
  updateBookingAction,
} from "../api/booking-action";
import {
  getAirports,
  getAllbookings,
  getAllSearchedbookings,
  getDateTimeDetailIST,
  getDestinationWithRegion,
  getDistanceInKm,
  getDuration,
  getgroupIds,
  getLatLanOfDestination,
  getLatLanOfSource,
  getTimeDetails,
  searchingCarsWaiting,
  setaffiliatePaymentPendingBookings,
  setAllAmmendments,
  setAllFinanceAmmendments,
  setAllOpsAmmendments,
  setAmmendmentCount,
  setAmmendmentDataLoading,
  setBookingDetails,
  setBookingDetailsById,
  setBookingInitiateLoading,
  setCurrencyPrice,
  setDestinationRegionCheck,
  setFinanceAmmendmentCount,
  setFinanceAmmendmentDataLoading,
  setFlightArrivalDepartureData,
  setFlightArrivalDepartureErrorData,
  setFlightData,
  setFlightLoading,
  setGeneratedBookingGroupID,
  setIsBookingLoading,
  setJobsForTodayBookings,
  setJobsForTomorrowBookings,
  setMultiCloneBookingLoading,
  setOpsAmmendmentCount,
  setOpsAmmendmentDataLoading,
  setPaginatedBookingCount,
  setPaginatedTodayBookingCount,
  setPaginatedTomorrowBookingCount,
  setPaginatedunassignedBookingCount,
  setPobBookings,
  setPostalCodeDestination,
  setPostalCodeSource,
  setSearchedBookingCount,
  setSingleBookingDetailLoading,
  setSourceRegionCheck,
  setTotalBookingCount,
  setTotalTodayBookingCount,
  setTotalTomorrowBookingCount,
  setTotalunassignedBookingCount,
  setUnassignedJobs,
  setUploading,
} from "../redux/app/booking/booking-slice";
import {
  getVehicles,
  getVehiclesErr,
  setDistance,
  setDuration,
} from "../redux/app/vehicle/vehicle-slice";
import { toast } from "react-toastify";

const getBookingState = (state) => state.booking;
const getVehicleState = (state) => state.vehicle;
const getMapState = (state) => state.map;

let regionLatLan = {
  sourcelatlan: undefined,
  destinationlatlan: undefined,
};

export function* placesLatLangOfSource(actions) {
  // get booking state

  try {
    // gettting lat and lang of source from google api placeid
    const response = yield call(getLatLongSourceAction, actions.payload);

    regionLatLan.sourcelatlan =
      response.data.result?.lat + "," + response.data.result?.lng;
    // then get the lat and lang of the source and set it in the redux store
    yield put(
      getLatLanOfSource({
        sourceLatLan:
          response.data?.result?.lat + "," + response.data.result?.lng,
      })
    );

    yield put(
      setPostalCodeSource({
        postalCodeSource: response.data?.address,
      })
    );

    // if source is there then get time details of the source

    yield put({
      type: "GET_TIME_DETAILS",
      payload: {
        lng: parseFloat(response?.data?.result?.lng),
        lat: parseFloat(response?.data?.result?.lat),
      },
    });
  } catch (error) {
    toast.error(error?.response?.data);
  }
}

export function* placesLatLangOfDestination(actions) {
  // get booking state

  try {
    // gettting lat and lang of source from google api placeid
    const response = yield call(getLatLongDestinationAction, actions.payload);

    // then check if the destination is in the region or not
    // const destinationWithinRgionResponse = yield call(
    //   getMatchingRegionsAction,
    //   { lat: response.data.lat, lng: response.data.lng }
    // );

    // if destination is in the region then get the region and set it in the redux store
    // yield put(
    //   getDestinationWithRegion({
    //     destinationWithRegion: destinationWithinRgionResponse.data,
    //   })
    // );

    regionLatLan.destinationlatlan =
      response?.data?.result?.lat + "," + response?.data?.result?.lng;
    // then get the lat and lang of the destination and set it in the redux store
    yield put(
      getLatLanOfDestination({
        destinationLatLan:
          response?.data?.result?.lat + "," + response?.data?.result?.lng,
      })
    );

    yield put(
      setPostalCodeDestination({
        postalCodeDestination: response.data?.address,
      })
    );
  } catch (error) {
    toast.error(error?.response?.data);
  }
}

export function* timeDetailsOfSelectedSourceOrDest(actions) {
  try {
    const response = yield call(getTimeDetailsAction, actions.payload);

    yield put(
      getTimeDetails({
        timeDetails: response.data,
      })
    );

    if (actions.payload?.travellDateTime && response.status === 200) {
      yield put({
        type: "GET_DATE_TIME_DETAILS_IST",
        payload: {
          travellDateTime: actions.payload?.travellDateTime,
          IndianTimezone: actions.payload?.IndianTimezone,
          travellTimeZone: response.data?.timezone,
        },
      });
    }
  } catch (error) {
    toast.error(error?.response?.data);
  }
}

// getting distance(km) between source and destination
export function* getDistanceBetweenSourceAndDestination(actions) {
  try {
    const response = yield call(getDistanceBetweenSourceAndDestinationAction, {
      sourcelatlng: actions.payload.sourcelatlng,
      destlatlng: actions.payload.destlatlng,
    });

    if (response?.data?.km !== null) {
      yield put(
        getDistanceInKm({
          distance: response?.data?.km,
        })
      );

      yield put(
        getDuration({
          bookingDuration: response?.data?.duration,
        })
      );
    } else {
      // alert("⚠️ Vehicles are not available for this route");
      toast.error("⚠️ Vehicles are not available for this route");
    }
  } catch (error) {
    toast.error(error?.response?.data);
  }
}

export function* getDistanceBetweenSourceAndDestinationMapbox(actions) {
  try {
    const response = yield call(
      getDistanceBetweenSourceAndDestinationMapboxAction,
      {
        slat: actions.payload.slat,
        dlat: actions.payload.dlat,
        slng: actions.payload.slng,
        dlng: actions.payload.dlng,
      }
    );

    if (response?.data?.km !== null) {
      yield put(
        getDistanceInKm({
          distance: response?.data?.km,
        })
      );

      yield put(
        getDuration({
          bookingDuration: response?.data?.duration,
        })
      );
    } else {
      // alert("⚠️ Vehicles are not available for this route");
      toast.error("⚠️ Vehicles are not available for this route");
    }
  } catch (error) {
    toast.error(error?.response?.data);
  }
}

// 1 get matching regions
export function* getMatchingRegionsAndSearchVehicle(actions) {
  let bookingState = yield select(getBookingState);
  let vehicleState = yield select(getVehicleState);
  yield put(
    searchingCarsWaiting({
      isSearhingCar: true,
    })
  );

  // if (actions.payload?.b2b) {
  //   // actions.payload.navigate("/newbooking/searchResult");
  // } else {
  //   actions.payload.navigate("/searchResult");
  // }

  yield put(
    searchingCarsWaiting({
      isSearhingCar: false,
    })
  );
}

// for hourly searhing result
export function* getMatchingRegionsAndSearchVehicleHourly(actions) {
  yield put(
    searchingCarsWaiting({
      isSearhingCar: true,
    })
  );

  if (actions.payload?.b2b) {
    // actions.payload.navigate("/newbooking/searchResult");
  } else {
    actions.payload.navigate("/searchResult");
  }

  yield put(
    searchingCarsWaiting({
      isSearhingCar: false,
    })
  );
}

//3 get vehicles with price
export function* getVehiclesWithPrice(actions) {
  let mapState = yield select(getMapState);
  let response;

  response = yield call(searchVehiclesAction, actions.payload);

  if (!response?.data?.errmsg) {
    yield put(
      getVehicles({
        vehicle: response?.data?.vehicleWithPriceArray,
      })
    );
    yield put(
      getDistanceInKm({
        distance: response?.data?.km,
      })
    );
    // vehicleWithPricevalueObj
    yield put(
      setCurrencyPrice({
        currencyprice: response?.data?.vehicleWithPricevalueObj,
      })
    );
  } else {
    yield put(
      getVehiclesErr({
        err: response?.data?.errmsg,
      })
    );
    toast.error(response?.data?.errmsg);
  }
}

function* getVehiclesWithPriceFlatRateSaga(actions) {
  try {
    const response = yield call(
      searchVehicleWithPriceFlateRateAction,
      actions.payload
    );

    if (response.status === 200) {
      if (response?.data?.errmsg) {
        yield put(
          getVehiclesErr({
            err: response?.data?.errmsg,
          })
        );
        // toast.error(response?.data?.errmsg);
        setTimeout(() => {
          actions.payload.navigate("/flatrates");
        }, 3000);
      }

      yield put(
        getVehicles({
          vehicle: response?.data?.vehicleWithPriceArray,
        })
      );
      yield put(
        setDistance({
          distanceflat: response?.data?.km,
        })
      );
      yield put(
        setDuration({
          durationflat: response?.data?.durationInMin,
        })
      );

      yield put(
        setCurrencyPrice({
          currencyprice: response?.data?.vehicleWithPricevalueObj,
        })
      );
    }
  } catch (error) {
    toast.error(error?.response?.data);
  }
}

export function* getCurrencyLayerSaga(actions) {
  const response = yield call(getCurrencyLayerApiAction, actions.payload);
}

export function* getVehicleWithPriceHourly(actions) {
  const response = yield call(searchVehiclesHourlyPriceAction, actions.payload);

  if (!response?.data?.errmsg) {
    yield put(
      getVehicles({
        vehicle: response?.data?.vehicleWithPriceArray,
      })
    );
    yield put(
      getDistanceInKm({
        distance: response?.data?.km,
      })
    );
    yield put(
      setCurrencyPrice({
        currencyprice: response?.data?.vehicleWithPricevalueObj,
      })
    );
  } else {
    yield put(
      getVehiclesErr({
        err: response?.data?.errmsg,
      })
    );
  }
}

export function* bookingInitiateWithVehicleSaga(actions) {
  console.log("bookingInitiateWithVehicleSaga========>", actions);
  yield put(
    setBookingInitiateLoading({
      bookingInitiateLoading: true,
    })
  );
  const response = yield call(
    bookingInitiateWithVehicleAction,
    actions.payload.payload
  );

  if (response.status === 200) {
    if (actions.payload?.flatrate) {
      actions.payload.navigate("/flatrate/searchResult/passengerDetail");
    } else if (actions.payload?.b2b) {
      actions.payload.navigate("/newbooking/searchResult/passengerDetail");
    } else {
      actions.payload.navigate("/passengerDetail");
    }
    yield put(
      setBookingInitiateLoading({
        bookingInitiateLoading: false,
      })
    );
  }

  yield put(
    setBookingDetails({
      booking: response.data,
    })
  );
}

export function* confirmBookingWithPassengerDetailSaga(actions) {
  yield put(
    setBookingInitiateLoading({
      bookingInitiateLoading: true,
    })
  );
  const response = yield call(
    confirmBookingWithPassengerDetailAction,
    actions.payload.passenger
  );

  if (response?.status === 200) {
    if (actions.payload?.flatrate) {
      actions.payload.navigate(
        "/flatrate/searchResult/passengerDetail/bookingSummary"
      );
    } else if (actions?.payload?.b2b) {
      actions.payload.navigate(
        "/newbooking/searchResult/passengerDetail/bookingSummary"
      );
    } else {
      actions.payload.navigate("/bookingSummary");
    }
  }
  yield put(
    setBookingInitiateLoading({
      bookingInitiateLoading: false,
    })
  );
}

export function* getAllBookingsSaga(actions) {
  yield put(
    setIsBookingLoading({
      bookingIsloading: true,
    })
  );
  // const response = yield call(getBookingDetailsAction, actions.payload);

  // if (response.length >= 0) {
  //   yield put(
  //     setIsBookingLoading({
  //       bookingIsloading: false,
  //     })
  //   );
  // }

  // yield put(
  //   getAllbookings({
  //     allBookings: response,
  //   })
  // );

  // new code
  const response = yield call(
    getAllBookingWithoutSearchAction,
    actions.payload
  );

  console.log("getAllBookingWithoutSearchAction 1===>", response);
  console.log(
    "getAllBookingWithoutSearchAction===>",
    response?.data?.allBookingDetails[0]?.paginatedResults
  );

  if (response?.status === 200) {
    if (response?.data?.allBookingDetails[0]?.paginatedResults?.length >= 0) {
      yield put(
        setIsBookingLoading({
          bookingIsloading: false,
        })
      );
    }
    yield put(
      getAllbookings({
        allBookings: response?.data?.allBookingDetails[0]?.paginatedResults,
      })
    );

    yield put(
      setTotalBookingCount({
        totalBookingCount:
          response?.data?.allBookingDetails[0]?.totalBookingCount[0]?.total,
      })
    );
    yield put(
      setPaginatedBookingCount({
        paginatedBookingCount: response?.data?.paginationBookingCount,
      })
    );
  }
}

export function* getBookingDetailsSaga(actions) {
  yield put(
    setSingleBookingDetailLoading({
      singleBookingDetailLoading: true,
    })
  );
  const response = yield call(getBookingDetailsByIdAction, actions.payload);

  if (response) {
    yield put(
      setSingleBookingDetailLoading({
        singleBookingDetailLoading: false,
      })
    );
  }

  yield put(
    setBookingDetailsById({
      bookingDetailsById: response,
    })
  );
}

// confirm booking with payment
export function* confirmBookingWithPaymentSaga(actions) {
  yield put({
    type: "UPDATE_BOOKING",
    payload: actions.payload,
  });

  toast.success("Booking Confirmed");

  actions.payload.navigate(
    "/newbooking/searchResult/passengerDetail/bookingSummary/bookingStatus"
  );
}

export function* getAirPortDbSaga(actions) {
  const response = yield call(getAirPortDbAction);

  yield put(
    getAirports({
      airPorts: response,
    })
  );
}

export function* updateBookingSaga(actions) {
  let response;

  yield put(
    setUploading({
      uploadingInvoiceStatus: true,
    })
  );

  response = yield call(updateBookingAction, actions.payload);

  if (response.status === 200) {
    toast.dismiss();
    toast.success(actions.payload.msg);

    if (actions.payload.affiliate) {
      toast.loading("Sending Cancel Voucher to Affiliate");
      const response = yield call(
        sendCancelBookingVoucherAction,
        actions.payload
      );
      if (response.status === 200) {
        toast.dismiss();
        toast.success("Voucher Sent");
      }
    }
  }

  yield put(
    setBookingDetails({
      booking: response.data,
    })
  );
  yield put(
    setUploading({
      uploadingInvoiceStatus: false,
    })
  );

  if (actions.payload.bookingId) {
    yield put({
      type: "GET_BOOKING_DETAILS_BY_ID",
      payload: { id: actions.payload?.bookingId },
    });
  } else {
    yield put({
      type: "GET_BOOKING_DETAILS_BY_ID",
      payload: { id: actions.payload.body?.bookingId },
    });
  }
}

export function* matchingRegionSourceSaga(actions) {
  yield put(
    setSourceRegionCheck({
      checkSourceRegion: false,
    })
  );
  const response = yield call(checkSourceIsInRegionAction, actions.payload);
  if (response.status === 200) {
    yield put(
      setSourceRegionCheck({
        checkSourceRegion: true,
      })
    );
  }
}

export function* matchingRegionDestinationSaga(actions) {
  yield put(
    setDestinationRegionCheck({
      checkDestinationRegion: false,
    })
  );
  const response = yield call(
    checkDestinationIsInRegionAction,
    actions.payload
  );

  if (response.status === 200) {
    yield put(
      setDestinationRegionCheck({
        checkDestinationRegion: true,
      })
    );
  }
}

export function* getFlightDataSaga(actions) {
  yield put(
    setFlightLoading({
      flightLoading: true,
    })
  );
  yield put(
    setFlightData({
      flightData: {},
    })
  );
  const response = yield call(flightApiAction, actions.payload);

  if (response?.error?.errorMessage) {
    toast.error(response?.error?.errorMessage, {
      delay: 5000,
    });
  }
  yield put(
    setFlightData({
      flightData: response?.flightStatuses && response?.flightStatuses[0],
    })
  );
  yield put(
    setFlightLoading({
      flightLoading: false,
    })
  );
}

export function* getFlightArrivalDateSaga(actions) {
  try {
    yield put(
      setFlightArrivalDepartureData({
        flightArrivalDepartureData: {},
      })
    );
    yield put(
      setFlightArrivalDepartureErrorData({
        flightArrivalDepartureErrorData: "",
      })
    );

    const response = yield call(flightArrivalDateApiAction, actions.payload);

    if (response?.error?.errorMessage) {
      toast.error(response?.error?.errorMessage, {
        delay: 5000,
      });
    }

    yield put(
      setFlightArrivalDepartureData({
        flightArrivalDepartureData:
          response?.scheduledFlights && response?.scheduledFlights[0],
      })
    );

    if (response?.error?.errorMessage) {
      yield put(
        setFlightArrivalDepartureErrorData({
          flightArrivalDepartureErrorData: response?.error?.errorMessage,
        })
      );
    }
  } catch (error) {}
}

export function* getFlightDepartureDateSaga(actions) {
  try {
    yield put(
      setFlightArrivalDepartureData({
        flightArrivalDepartureData: {},
      })
    );
    yield put(
      setFlightArrivalDepartureErrorData({
        flightArrivalDepartureErrorData: "",
      })
    );

    const response = yield call(flightDepartureDateApiAction, actions.payload);

    if (response?.error?.errorMessage) {
      toast.error(response?.error?.errorMessage, {
        delay: 5000,
      });
    }
    yield put(
      setFlightArrivalDepartureData({
        flightArrivalDepartureData:
          response?.scheduledFlights && response?.scheduledFlights[0],
      })
    );

    if (response?.error?.errorMessage) {
      yield put(
        setFlightArrivalDepartureErrorData({
          flightArrivalDepartureErrorData: response?.error?.errorMessage,
        })
      );
    }
  } catch (error) {}
}

export function* searchInitiate(actions) {}

export function* searchVehicleWithPriceSequence() {
  const requestChannel = yield actionChannel("SEARCH_INITIATE");

  while (true) {
    yield take(requestChannel);
    let bookingState = yield select(getBookingState);

    yield put({
      type: "GET_VEHICLES_WITH_PRICE",
      payload: {
        date: bookingState?.dateChange,
        km: bookingState?.distance,
      },
    });
  }
}

export function* totallBookingSaga(actions) {
  const response = yield call(totalBokingAction, actions.payload);

  yield put(
    setTotalBookingCount({
      totalBookingCount: response?.totalBookingCount,
    })
  );
}

export function* sendinvoiceSaga(actions) {
  toast.success("Invoice Sent ");
  yield call(sendInvoiceAction, actions.payload);
}

export function* sendVoucherSaga(actions) {
  toast.success("Voucher sent");
  yield call(sendVoucherAction, actions.payload);
}

export function* sendVoucherb2cSaga(actions) {
  toast.success("Voucher sent");
  yield call(sendVoucherb2cAction, actions.payload);
}

export function* sendAffiliateVoucherSaga(actions) {
  toast.success("Voucher sent");
  yield call(sendAffiliateVoucherAction, actions.payload);
}

export function* sendDriverDetailSaga(actions) {
  toast.success("Driver Detail Sent");
  yield call(driverDetailMailAction, actions.payload);
}

export function* passengerDetailUpdateSaga(actions) {
  const response = yield call(passengerDetailsUpdateAction, actions.payload);
}

export function* bookingHistoryCreateSaga(actions) {
  const response = yield call(bookingHistoryCreateAction, actions.payload);
}

export function* jobsfortodaySaga(action) {
  const response = yield call(jobsForTodayAction, action.payload);

  // if (response?.success === true) {
  //   yield put(
  //     setJobsForTodayBookings({
  //       jobsForTodayBookings: response.bookingsfortoday,
  //     })
  //   );
  // }

  if (response?.data?.todayBookingDetails?.length > 0) {
  }

  if (response?.status === 200) {
    if (response?.data?.todayBookingDetails?.sortedBookings?.length > 0) {
      yield put(
        setJobsForTodayBookings({
          jobsForTodayBookings:
            response?.data?.todayBookingDetails?.sortedBookings,
        })
      );
      yield put(
        setTotalTodayBookingCount({
          totalTodayBookingsCount: response?.data?.todayBookingDetails?.total,
        })
      );
      yield put(
        setPaginatedTodayBookingCount({
          paginatedTodayBookingsCount: response?.data?.paginationBookingCount,
        })
      );
    }
  }
}

export function* jobsfortomorrowSaga(action) {
  const response = yield call(jobsForTomorrowAction, action.payload);

  // if (response?.success === true) {
  //   yield put(
  //     setJobsForTomorrowBookings({
  //       jobsForTomorrowBookings: response.bookingsfortomorrow,
  //     })
  //   );
  // }

  if (response?.status === 200) {
    if (
      response?.data?.tomorrowBookingDetails?.sortedBookingsTomorrow?.length > 0
    ) {
      yield put(
        setJobsForTomorrowBookings({
          jobsForTomorrowBookings:
            response?.data?.tomorrowBookingDetails?.sortedBookingsTomorrow,
        })
      );

      yield put(
        setTotalTomorrowBookingCount({
          totalTomorrowBookingsCount:
            response?.data?.tomorrowBookingDetails?.total,
        })
      );
      yield put(
        setPaginatedTomorrowBookingCount({
          paginatedTomorrowBookingsCount:
            response?.data?.paginationBookingCount,
        })
      );
    }
  }
}

export function* affiliatePaymentPendingBookingsSaga(actions) {
  try {
    const responseToday = yield call(jobsForTodayAction, actions.payload);
    const responseTomorrow = yield call(jobsForTomorrowAction, actions.payload);

    const data = [
      ...responseToday?.data?.todayBookingDetails?.sortedBookings,
      ...responseTomorrow?.data?.tomorrowBookingDetails?.sortedBookingsTomorrow,
    ];

    yield put(
      setaffiliatePaymentPendingBookings({
        affiliatePaymentPendingBookings: data,
      })
    );
  } catch (error) {
    // toast.error("Something went wrong");
  }
}

export function* unassignedjobsSaga(action) {
  const response = yield call(unassignedJobsAction, action.payload);

  // if (response?.success === true) {
  //   yield put(
  //     setUnassignedJobs({
  //       unassignedJobs: response.unAssignedBookings,
  //     })
  //   );
  // }

  if (response?.status === 200) {
    if (response?.data?.unAssignedDetails?.sortedBookingsUnassign?.length > 0) {
      yield put(
        setUnassignedJobs({
          unassignedJobs:
            response?.data?.unAssignedDetails?.sortedBookingsUnassign,
        })
      );

      yield put(
        setTotalunassignedBookingCount({
          totalunassignedBookingsCount:
            response?.data?.unAssignedDetails?.total,
        })
      );
      yield put(
        setPaginatedunassignedBookingCount({
          paginatedunassignedBookingsCount:
            response?.data?.paginationBookingCount,
        })
      );
    }
  }
}

export function* getVehicleUnitPriceSaga(actions) {
  try {
    const response = yield call(getVehicleUnitPriceAction, actions.payload);

    if (response.status === 200) {
      yield put(
        setCurrencyPrice({
          currencyprice: response?.data?.vehicleWithPricevalueObj,
        })
      );
    }
  } catch (error) {}
}

function* sendWatiMsgSaga(actions) {
  try {
    toast.loading("Sending Message");
    const response = yield call(sendWatiMsgAction, actions.payload);

    if (response.status === 200) {
      toast.dismiss();
      toast.success("Message Sent");
    }
  } catch (error) {
    toast.error("Something went wrong");
  }
}

function* createDuplicateBooking(actions) {
  try {
    toast.loading("Cloning Booking");
    const response = yield call(createDuplicateBookingAction, actions.payload);
    if (response.status === 200) {
      toast.dismiss();
      toast.success("Booking Cloned Successfully");
    }
  } catch (error) {
    toast.error("Something went wrong");
  }
}
function* createMultipleDuplicateBooking(actions) {
  try {
    // toast.loading("Multi Cloning Booking");
    yield put(setMultiCloneBookingLoading({ multiCloneBookingLoading: true }));
    const response = yield call(
      createMultipleDuplicateBookingAction,
      actions.payload
    );
    if (response.status === 200) {
      // toast.dismiss();
      yield put(
        setMultiCloneBookingLoading({ multiCloneBookingLoading: false })
      );
      // toast.success("Multiple Booking Cloned Successfully");
      response.data.bookingResponse.forEach((sBooking) => {
        if (sBooking.emailSent) {
          toast.success(`Voucher sent for booking ID: ${sBooking.bookingId}`);
        }
      });
    }
  } catch (error) {
    toast.error("Something went wrong");
    yield put(setMultiCloneBookingLoading({ multiCloneBookingLoading: false }));
  }
}

function* bookingPaymentAction(action) {
  try {
    const response = yield call(boookingPaymentAction, action.payload);
    if (response.status === 200) {
      toast.dismiss();
      toast.success("Payment Successfull");
      action.payload.navigate("/bookingStatus");
    }
  } catch (error) {
    toast.error(error?.message);
  }
}

function* timeDetailsOfSelectedSourceOrDestIST(action) {
  try {
    const response = yield call(getISTConvertedTimeAction, action.payload);

    if (response.status === 200) {
      yield put(getDateTimeDetailIST({ dateTimeIST: response?.data?.data }));
    }
  } catch (error) {
    toast.error(error?.message);
  }
}

export function* getAllBookingsWithSearchSaga(actions) {
  yield put(
    setIsBookingLoading({
      bookingIsloading: true,
    })
  );
  // new code
  const response = yield call(getAllBookingWithSearchAction, actions.payload);

  if (response?.status === 200) {
    if (response?.data?.allBookingDetails[0]?.paginatedResults?.length >= 0) {
      yield put(
        setIsBookingLoading({
          bookingIsloading: false,
        })
      );
    }
    yield put(
      getAllSearchedbookings({
        allSearchedBookings:
          response?.data?.allBookingDetails[0]?.paginatedResults,
      })
    );

    yield put(
      setSearchedBookingCount({
        searchedBookingCount:
          response?.data?.allBookingDetails[0]?.totalBookingCount.length > 0
            ? response?.data?.allBookingDetails[0]?.totalBookingCount[0]?.total
            : 0,
      })
    );
    // yield put(
    //   setTotalBookingCount({
    //     // totalBookingCount: response?.data?.allBookingDetails[0]?.totalBookingCount[0]?.total,
    //   })
    // );
    yield put(
      setPaginatedBookingCount({
        paginatedBookingCount: response?.data?.paginationBookingCount,
      })
    );
  }
}

function* createGroupBookingSaga(actions) {
  try {
    toast.loading("Grouping...");
    const response = yield call(createGroupBookingAction, actions.payload);

    if (response.status === 200) {
      toast.dismiss();
      toast.success("Booking grouped Successfully");
    }
  } catch (error) {
    toast.error("Something went wrong");
  }
}

function* getGroupIdsSaga(actions) {
  try {
    const response = yield call(getGroupIdsAction, actions.payload);
    console.log(response?.data?.data, "enrespos");
    if (response.status === 200) {
      yield put(getgroupIds(response?.data?.data));
    }
  } catch (error) {}
}

function* groupInSaga(actions) {
  try {
    const response = yield call(groupInBookingsAction, actions.payload);
    if (response.status === 200) {
      toast.dismiss();
      toast.success("Booking grouped Successfully");
    }
  } catch (err) {
    toast.error("Something went wrong");
  }
}

function* groupOutSaga(actions) {
  try {
    const response = yield call(groupOutBookingsAction, actions.payload);
    if (response.status === 200) {
      toast.dismiss();
      toast.success("Booking removed from group Successfully");
    }
  } catch (err) {
    toast.error("Something went wrong");
  }
}

function* invoiceAddInGroupedBookingsSaga(actions) {
  try {
    toast.loading("Adding Invoice to Group");
    const response = yield call(
      addInvoiceToGroupedBookingAction,
      actions.payload
    );
    if (response.status === 200) {
      toast.dismiss();
      toast.success("Invoice added to group Successfully");
    }
  } catch (err) {
    toast.error("Something went wrong");
  }
}

function* chnageBookingStatusToPobSaga(actions) {
  try {
    toast.loading("Changing Booking Status to POB");
    const response = yield call(
      changeBookingStatusToPobAction,
      actions.payload
    );
    if (response.status === 200) {
      toast.dismiss();
      toast.success("Booking Status Changed to POB Successfully");

      yield put({
        type: "GET_BOOKING_DETAILS_BY_ID",
        payload: { id: actions.payload.bookingId },
      });
    }
  } catch (error) {
    toast.error("Something went wrong");
  }
}

function* pobBookingsListSaga(actions) {
  try {
    const response = yield call(bookinginProgressForPOBAction, actions.payload);
    if (response.status === 200) {
      yield put(
        setPobBookings({
          pobBookings: response?.data?.bookings,
        })
      );
    }
  } catch (error) {
    toast.error("Something went wrong");
    console.log(error);
  }
}

function* deleteCreditCardsFromBookingSaga(actions) {
  try {
    const response = yield call(
      deleteCreditCardsFromBookingAction,
      actions.payload
    );
    if (response.status === 200) {
      toast.success("Credit Card Deleted Successfully");
    }
  } catch (error) {
    toast.error("Something went wrong");
  }
}

function* affiliatePaymentStatusSaga(actions) {
  try {
    const response = yield call(affiliatePaymentStatusAction, actions.payload);
    if (response.status === 200) {
      toast.success("Payment Status Updated Successfully");

      yield put({
        type: "GET_BOOKING_DETAILS_BY_ID",
        payload: { id: actions.payload.body.bookingId },
      });
    }
  } catch (error) {
    toast.error("Something went wrong");
  }
}

function* checkOpsAmmendmentSaga(actions) {
  try {
    const response = yield call(ammendmentCheckedAction, actions.payload);
    if (response.status === 200) {
      toast.success(`${actions.payload?.bookingId} Checked Successfully`);
      yield put({
        type: "GET_ALL_OPS_AMMENDMENT",
        payload: {
          token: actions.payload.token,
        },
      });
    }
  } catch (error) {
    toast.error("Something went wrong", error);
  }
}

function* checkFinAmmendmentSaga(actions) {
  console.log("checkFinAmmendmentSaga", actions.payload);
  try {
    const response = yield call(ammendmentCheckedAction, actions.payload);
    if (response.status === 200) {
      toast.success(`${actions.payload?.bookingId} Checked Successfully`);
      yield put({
        type: "GET_ALL_FINANCE_AMMENDMENT",
        payload: {
          token: actions.payload.token,
        },
      });
    }
  } catch (error) {
    toast.error("Something went wrong", error);
  }
}

function* getAllFinanceAmmendmentSaga(actions) {
  try {
    yield put(
      setFinanceAmmendmentDataLoading({ ammendmentFinanceDataLoading: true })
    );
    const response = yield call(getAllFinAmmendmentAction, actions.payload);
    if (response.status === 200) {
      yield put(
        setAllFinanceAmmendments({
          allFinanceAmmendments: response.data.allAmendment,
        })
      );
      yield put(
        setFinanceAmmendmentDataLoading({ ammendmentFinanceDataLoading: false })
      );
    }
  } catch (error) {
    toast.error("Something went wrong", error);
  }
}

function* getAllFinanceUncheckedAmmendmentCountSaga(actions) {
  try {
    const response = yield call(
      getAllFinUncheckedAmmendmentCountAction,
      actions.payload
    );
    if (response.status === 200) {
      yield put(
        setFinanceAmmendmentCount({
          ammendmentFinanceCount: response.data.uncheckedCount,
        })
      );
    }
  } catch (error) {
    toast.error("Something went wrong", error);
  }
}

function* getAllOpsAmmendmentSaga(actions) {
  try {
    yield put(setOpsAmmendmentDataLoading({ ammendmentOpsDataLoading: true }));
    const response = yield call(getAllOpsAmmendmentAction, actions.payload);
    if (response.status === 200) {
      yield put(
        setAllOpsAmmendments({ allOpsAmmendments: response.data.allAmendment })
      );
      yield put(
        setOpsAmmendmentDataLoading({ ammendmentOpsDataLoading: false })
      );
    }
  } catch (error) {
    toast.error("Something went wrong", error);
  }
}

function* getAllOpsFinanceUncheckedAmmendmentCountSaga(actions) {
  try {
    const response = yield call(
      getAllOpsUncheckedAmmendmentCountAction,
      actions.payload
    );
    if (response.status === 200) {
      yield put(
        setOpsAmmendmentCount({
          ammendmentOpsCount: response.data.uncheckedCount,
        })
      );
    }
  } catch (error) {
    toast.error("Something went wrong", error);
  }
}

// function* generatedBookingIdSaga(actions) {
//   try {
//     toast.loading("Generating Booking ID");
//     const response = yield call(generatedBookingIdAction, actions.payload);

//     console.log("generatedBookingIdAction", response.data.data);
//     if (response.status === 200) {
//       toast.dismiss();

//       yield put(
//         setGeneratedBookingGroupID({
//           generatedBookingGroupID: response?.data?.data,
//         })
//       );
//       toast.success("Booking ID Generated Successfully");
//     }
//   } catch (error) {
//     toast.error("Something went wrong", error);
//   }
// }

export function* watchBookingAsync() {
  yield takeLatest(
    "AFFILIATE_PAYMENT_PENDING",
    affiliatePaymentPendingBookingsSaga
  );
  yield takeLatest("SEARCH_INITIATE", searchInitiate);
  yield takeLatest("GET_LAT_LAN_OF_SOURCE", placesLatLangOfSource);
  yield takeLatest("GET_LAT_LAN_OF_DESTINATION", placesLatLangOfDestination);
  yield takeLatest("GET_TIME_DETAILS", timeDetailsOfSelectedSourceOrDest);
  yield takeLatest(
    "GET_DATE_TIME_DETAILS_IST",
    timeDetailsOfSelectedSourceOrDestIST
  );
  yield takeLatest(
    "GET_MATCHING_REGIONS_AND_SEARCH_VEHICLE",
    getMatchingRegionsAndSearchVehicle
  );

  yield takeLatest(
    "GET_DISTANCE_BETWEEN_SOURCE_AND_DESTINATION",
    getDistanceBetweenSourceAndDestination
  );
  yield takeLatest(
    "GET_DISTANCE_BETWEEN_SOURCE_AND_DESTINATION_MAPBOX",
    getDistanceBetweenSourceAndDestinationMapbox
  );
  yield takeLatest("GET_VEHICLES_WITH_PRICE", getVehiclesWithPrice);
  yield takeLatest(
    "BOOKING_INITIATE_WITH_VEHICLE",
    bookingInitiateWithVehicleSaga
  );
  yield takeLatest(
    "CONFIRM_BOOKING_WITH_PASSENGER_DETAIL",
    confirmBookingWithPassengerDetailSaga
  );
  yield takeLatest("GET_ALL_BOOKINGS", getAllBookingsSaga);
  yield takeLatest(
    "GET_ALL_BOOKINGS_WITH_SEARCH",
    getAllBookingsWithSearchSaga
  );
  yield takeLatest("GET_BOOKING_DETAILS_BY_ID", getBookingDetailsSaga);
  yield takeLatest("GET_AIRPORTS_DB", getAirPortDbSaga);
  yield takeLatest("GET_VEHICLES_WITH_PRICE_HOURLY", getVehicleWithPriceHourly);
  yield takeLatest(
    "GET_MATCHING_REGIONS_AND_SEARCH_VEHICLE_HOURLY",
    getMatchingRegionsAndSearchVehicleHourly
  );
  yield takeLatest("UPDATE_BOOKING", updateBookingSaga);
  yield takeLatest(
    "CONFIRM_BOOKING_WITH_PAYMENT",
    confirmBookingWithPaymentSaga
  );
  yield takeLatest("MATCHING_REGION_SOURCE", matchingRegionSourceSaga);
  yield takeLatest(
    "MATCHING_REGION_DESTINATION",
    matchingRegionDestinationSaga
  );
  yield takeLatest("TOTAL_BOOKING_COUNT", totallBookingSaga);
  yield takeLatest("CURRENCY_LAYER", getCurrencyLayerSaga);
  yield takeLatest("GET_FLIGHT_DATA", getFlightDataSaga);
  yield takeLatest("GET_FLIGHT_DATA_ARRIVAL", getFlightArrivalDateSaga);
  yield takeLatest("GET_FLIGHT_DATA_DEPARTURE", getFlightDepartureDateSaga);
  yield takeLatest("SEND_INVOICE", sendinvoiceSaga);
  yield takeLatest("SEND_VOUCHER", sendVoucherSaga);
  yield takeLatest("SEND_VOUCHER_B2C", sendVoucherb2cSaga);
  yield takeLatest("SEND_AFFILIATE_VOUCHER", sendAffiliateVoucherSaga);
  yield takeLatest("SEND_DRIVER_DETAIL", sendDriverDetailSaga);
  yield takeLatest("PASSENGER_DETAIL_UPDATE", passengerDetailUpdateSaga);

  yield takeLatest("BOOKING_HISTORY_CREATE", bookingHistoryCreateSaga);
  yield takeLatest("JOBS_FOR_TODAY", jobsfortodaySaga);
  yield takeLatest("JOBS_FOR_TOMORROW", jobsfortomorrowSaga);
  yield takeLatest("UNASSIGNED_JOBS", unassignedjobsSaga);
  yield takeLatest("GET_VEHICLE_UNIT_PRICE", getVehicleUnitPriceSaga);
  yield takeLatest("SEND_WATI_MSG", sendWatiMsgSaga);
  yield takeLatest("CREATE_DUPLICATE_BOOKING", createDuplicateBooking);
  yield takeLatest(
    "CREATE_MULTIPLE_DUPLICATE_BOOKING",
    createMultipleDuplicateBooking
  );
  yield takeLatest(
    "GET_VEHICLES_WITH_FLAT_PRICE",
    getVehiclesWithPriceFlatRateSaga
  );
  yield takeLatest("BOOKING_PAYMENT", bookingPaymentAction);
  yield takeLatest("CREATE_GROUP_BOOKING", createGroupBookingSaga);
  yield takeLatest("GET_GROUP_IDS", getGroupIdsSaga);
  yield takeLatest("GROUP_IN", groupInSaga);
  yield takeLatest("GROUP_OUT", groupOutSaga);
  yield takeLatest(
    "ADD_INVOICE_TO_GROUPED_BOOKINGS",
    invoiceAddInGroupedBookingsSaga
  );

  yield takeLatest(
    "CHANGE_BOOKING_STATUS_TO_POB",
    chnageBookingStatusToPobSaga
  );
  yield takeLatest("POB_BOOKINGS_LIST", pobBookingsListSaga);
  yield takeLatest(
    "DELETE_CREDIT_CARDS_FROM_BOOKING",
    deleteCreditCardsFromBookingSaga
  );
  yield takeLatest("AFFILIATE_PAYMENT_STATUS", affiliatePaymentStatusSaga);
  yield takeLatest("AMMENDMENT_FIN_CHECKED", checkFinAmmendmentSaga);
  yield takeLatest("AMMENDMENT_OPS_CHECKED", checkOpsAmmendmentSaga);

  yield takeLatest("GET_ALL_FINANCE_AMMENDMENT", getAllFinanceAmmendmentSaga);
  yield takeLatest(
    "GET_FINANCE_UNCHECKED_AMMENDMENT_COUNT",
    getAllFinanceUncheckedAmmendmentCountSaga
  );

  yield takeLatest("GET_ALL_OPS_AMMENDMENT", getAllOpsAmmendmentSaga);
  yield takeLatest(
    "GET_UNCHECKED_OPS_AMMENDMENT_COUNT",
    getAllOpsFinanceUncheckedAmmendmentCountSaga
  );
}
